import { FalloutPlayer, FalloutPlayerActionType, FalloutPrompt, FalloutPromptType, GamePhase, PromptTakeAction } from "../Data/Response";
import styles from './GameHeaderView.module.scss';

interface GameHeaderViewArgs {
    gameId: string;
    phase: GamePhase;
    prompt?: FalloutPrompt;
    players: FalloutPlayer[];
    loggedInUserId: string;
    actionPrompt?: PromptTakeAction;
    passHandler: () => void;
    endTurnHandler: () => void;
    resetHandler: () => void;
    round?: number;
}

const GameHeaderView: React.FC<GameHeaderViewArgs> = (args) => {

    const passView = (args.actionPrompt) ? <button>End Turn</button> : <button disabled={true}> End Turn</button>;

    return <div className={styles.root}>
        <h2>Game State <button onClick={e => args.resetHandler()}>Reset Game</button></h2>
        <p>Game Id: {args.gameId}</p>
        <p>Phase: {GetPhaseName(args.phase)}</p>
        <p>Round: {args.round ? args.round : "Not started"}</p>
        {args.prompt ? <PromptView prompt={args.prompt} players={args.players} loggedInUserId={args.loggedInUserId} /> : <p>No active prompt.</p>}
        <EndTurnButtonView actionPrompt={args.actionPrompt} passHandler={args.passHandler} endTurnHandler={args.endTurnHandler} />
    </div>
}

interface EndTurnButtonViewArgs {
    actionPrompt?: PromptTakeAction;
    passHandler: () => void;
    endTurnHandler: () => void;
}

const EndTurnButtonView: React.FC<EndTurnButtonViewArgs> = args => {

    const endTurnDisabled = !args.actionPrompt || args.actionPrompt.avaiablePlayerAction !== "endTurn";
    const passTurnDisabled = !args.actionPrompt || args.actionPrompt.avaiablePlayerAction !== "pass";
    return <ul className={styles.endTurnList}>
        <li>
            <button
                disabled={endTurnDisabled}
                onClick={e => {
                    console.log("click end turn");
                    args.endTurnHandler();
                }}
            >End Turn</button>
        </li>
        <li>
            <button
                disabled={passTurnDisabled}
                onClick={e => {
                    console.log("click pass");
                    args.passHandler();
                }}
            >Pass</button>
        </li>
    </ul>
}

interface PromptViewArgs {
    prompt: FalloutPrompt;
    players: FalloutPlayer[];
    loggedInUserId: string;
}

const PromptView: React.FC<PromptViewArgs> = args => {
    const playerName =
        args.loggedInUserId === args.prompt.promptedPlayerUserId
            ? "You have"
            : `${args.players.find(p => p.userId === args.prompt.promptedPlayerUserId).username ?? "Unknown Player"} has`;
    return <p>{playerName} been prompted to {GetPromptType(args.prompt.type)}</p>
}

export default GameHeaderView;

const GetPromptType = (prompt: FalloutPromptType): string => {
    switch (prompt) {
        case "placeMini": return "Place Mini";
        case "takeAction": return "Take an Action";
        case "rollDice": return "Roll Dice";
        case "confusionZone": return "get Control Zone";
    }
}

const GetPhaseName = (phase: GamePhase): string => {
    switch (phase) {
        case "initializing": return "Initializing";
        case "preparing": return "Preparing for Game";
        case "playing": return "Playing";
        case "completed": return "Completed";
        case "waitingForPlayers": return "Awaiting Players";
        default: return "Unhandled";
    }
}